import styled from "styled-components";
import { colors } from "utils";

const formatTeacher = (u) => {
  if (!u) return "";
  const name = [u.first_name, u.last_name].filter(Boolean).join(" ").trim();
  if (name) return name;
  return u.display_name || u.email || "Unnamed teacher";
};

export const TeacherModeBanner = ({ teacher, onStop }) => (
  <Banner>
    <BannerText>
      Acting as: <strong>{formatTeacher(teacher)}</strong>
    </BannerText>
    <StopButton onClick={onStop}>Stop Acting as Teacher</StopButton>
  </Banner>
);

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 32px;
  height: 48px;
  background: ${colors.pink800};
`;

const BannerText = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #fff;
  line-height: 16px;

  strong {
    font-weight: 700;
  }
`;

const StopButton = styled.button`
  background: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.pink800};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
